import LegalLayout from "@/components/LegalLayout";

export default function Confidentialite() {
  return (
    <LegalLayout title="Politique de Confidentialité" updated="1er février 2026">
      <div data-testid="privacy-page">
        <p>
          Ma Petite Yole respecte votre vie privée et se conforme au Règlement Général sur la
          Protection des Données (RGPD - Règlement UE 2016/679) et à la loi française « Informatique
          et Libertés » modifiée.
        </p>

        <h2>1. Responsable du traitement</h2>
        <p>
          <strong>Fabien Deris EI</strong> — éditeur de Ma Petite Yole.<br />
          Email : <a href="mailto:contact@mapetiteyole.com">contact@mapetiteyole.com</a>
        </p>

        <h2>2. Données collectées</h2>
        <p>Nous collectons uniquement les données strictement nécessaires au fonctionnement du Service :</p>
        <ul>
          <li><strong>Compte</strong> : prénom, adresse email, mot de passe chiffré (bcrypt).</li>
          <li><strong>Connexion Google</strong> (optionnelle) : identifiant Google, email, prénom.</li>
          <li><strong>Activité de jeu</strong> : ligue rejointe, yole favorite, pronostics par étape, points cumulés, historique des notifications.</li>
          <li><strong>Données techniques</strong> : adresse IP (logs de sécurité), user-agent, timestamps de connexion.</li>
          <li><strong>Notifications push</strong> (facultatif) : jeton d'abonnement du navigateur (si activées).</li>
        </ul>
        <p>
          <strong>Aucune donnée bancaire</strong> n'est collectée : le Service est entièrement gratuit
          et n'utilise pas de paiement.
        </p>

        <h2>3. Finalités</h2>
        <ul>
          <li>Créer et gérer votre compte utilisateur.</li>
          <li>Vous authentifier de manière sécurisée.</li>
          <li>Calculer les classements des ligues et de la saison.</li>
          <li>Vous envoyer des notifications liées au jeu (nouvelle étape, résultat, montée de fanion).</li>
          <li>Assurer la sécurité (détection de comptes frauduleux, protection anti-bot).</li>
        </ul>

        <h2>4. Base légale</h2>
        <ul>
          <li><strong>Exécution du contrat</strong> (utilisation du Service) pour les données de compte et de jeu.</li>
          <li><strong>Intérêt légitime</strong> pour les logs techniques et la sécurité.</li>
          <li><strong>Consentement</strong> pour les notifications push et la connexion Google.</li>
        </ul>

        <h2>5. Sous-traitants et destinataires</h2>
        <p>Vos données peuvent être traitées par les prestataires suivants, dans le cadre strict du fonctionnement du Service :</p>
        <ul>
          <li><strong>Emergent</strong> — hébergement de l'application, base MongoDB et stockage cloud (backups + photos).</li>
          <li><strong>Google</strong> — connexion Google OAuth (uniquement si vous choisissez ce mode).</li>
          <li><strong>Georacing</strong> — affichage du suivi en direct (iframe embed, aucune donnée personnelle transmise).</li>
        </ul>
        <p>
          <strong>Aucune donnée n'est vendue, louée ou cédée à des tiers à des fins commerciales.</strong>
        </p>

        <h2>6. Durée de conservation</h2>
        <ul>
          <li><strong>Compte actif</strong> : tant que vous utilisez le Service.</li>
          <li><strong>Compte inactif</strong> : suppression automatique après 3 ans d'inactivité.</li>
          <li><strong>Logs de sécurité</strong> : 12 mois maximum.</li>
          <li><strong>Sauvegardes de base de données</strong> : rétention des 14 dernières (renouvellement automatique toutes les 12h).</li>
        </ul>

        <h2>7. Vos droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul>
          <li><strong>Accès</strong> — obtenir une copie de vos données.</li>
          <li><strong>Rectification</strong> — corriger des données inexactes.</li>
          <li><strong>Effacement</strong> — supprimer votre compte et vos données.</li>
          <li><strong>Portabilité</strong> — recevoir vos données dans un format lisible.</li>
          <li><strong>Opposition et limitation</strong> — refuser certains traitements.</li>
          <li><strong>Retrait du consentement</strong> — désactiver les notifications à tout moment.</li>
        </ul>
        <p>
          Pour exercer un droit : envoyez un email à{" "}
          <a href="mailto:contact@mapetiteyole.com">contact@mapetiteyole.com</a> avec l'objet
          « RGPD ». Nous répondons dans un délai maximum de <strong>30 jours</strong>.
        </p>
        <p>
          Vous pouvez également introduire une réclamation auprès de la{" "}
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>
          {" "}(Commission Nationale de l'Informatique et des Libertés).
        </p>

        <h2>8. Cookies et stockage local</h2>
        <p>Nous utilisons uniquement des éléments techniques nécessaires au fonctionnement :</p>
        <ul>
          <li><strong>localStorage</strong> : conservation du jeton d'authentification JWT (pour rester connecté).</li>
          <li><strong>Service Worker</strong> : gestion des notifications push (si activées).</li>
        </ul>
        <p>
          <strong>Aucun cookie publicitaire ni traceur tiers n'est utilisé.</strong> Vous pouvez
          vider le stockage local depuis les paramètres de votre navigateur à tout moment.
        </p>

        <h2>9. Sécurité</h2>
        <p>
          Mots de passe chiffrés avec bcrypt, connexions en HTTPS uniquement, sauvegardes
          régulières, protection anti-bot à l'inscription (honeypot + délai). En cas de faille
          affectant vos données, nous vous en informerons dans les 72 heures.
        </p>
      </div>
    </LegalLayout>
  );
}
